<div class="state-modal">
    <div class="modal-dialog state-modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title">{{title}}</h2>
            </div>
            <div class="modal-body">
                <app-ordonnance-etat
                    *ngIf="etat !== etatRejetee || message !== ''; else rejetee"
                    (formSended)="formSended($event)"
                    [sendFormEvent]="sendFormSubject.asObservable()"
                    [message]="message"
                    [ordonnance]="ordonnance"
                    [etat]="etat"
                    [etatCode]="etatRejeteeCode">
                </app-ordonnance-etat>

                <ng-template #rejetee>
                    <div *ngIf="etatRejeteeCode === -1; else noRelation" class="buttons-section">
                        <button type="button" class="btn btn-rejetee"  style="background-color: #D38029; color: #FFFFFF" (click)="setMessagePhotoIllisible()">Photo illisible ou de mauvaise qualité</button>
                        <button type="button" class="btn btn-rejetee" style="background-color: #D38029; color: #FFFFFF" (click)="setPhotoNoRelation()">Photo sans rapport avec une ordonnance</button>
                    </div>

                    <ng-template #noRelation>
                        <div class="buttons-section">
                            <button type="button" class="btn btn-info btn-rejetee" (click)="rejectWithoutMail()">Rejeter sans notifier le bénéficiaire</button>
                            <button type="button" class="btn btn-info btn-rejetee" (click)="setMessagePhotoNoRelation()">Ajouter un motif pour le bénéficiaire</button>
                        </div>
                    </ng-template>
                </ng-template>
            </div>
            <div class="modal-footer">
                <button type="button" [disabled]="buttonDisabled" class="btn btn-giphar" (click)="closeModal()">Annuler</button>
                <button *ngIf="etat !== etatRejetee || message !== ''" type="button" [disabled]="buttonDisabled" class="btn btn-giphar" (click)="sendForm()">Envoyer Message</button>
            </div>
        </div>
    </div>
</div>

